import Vue from 'vue'
import Vuex from 'vuex'
import auth from "./modules/auth";
import config from "./modules/config.store";
import nav from "./modules/navigation";
import search from "./modules/search.store";
import wizard from "./modules/wizardprofile.store";
import profiles from "./modules/profile.store";
import exportpro from "./modules/exportpro.store";
import offer from "./modules/offer.store";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    config,
    nav,
    search,
    wizard,
    profiles,
    exportpro,
    offer
  }
})
